import React from 'react';

export default function VideoPlaybackControl({
  videoUrl,
  isPlayingBack,
  onStopPlayback,
}) {
  if (!videoUrl) return null;

  return (
    <>
      {isPlayingBack ? (
        <div className="lrp-webcam" style={{ position: 'relative' }}>
          <video
            key={`playback-${videoUrl}`}
            src={videoUrl}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            controls
            playsInline
          />
          <button
            onClick={onStopPlayback}
            title="Back to camera"
            aria-label="Back to camera"
            style={{ position: 'absolute', top: 8, left: 8, zIndex: 13, background: 'rgba(0,0,0,0.45)', color: '#fff', border: '1px solid rgba(255,255,255,0.25)', borderRadius: 4, padding: '4px 8px' }}
          >
            Back
          </button>
        </div>
      ) : null}
    </>
  );
}
